module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-BoldItalic.bfb7874.ttf";